import * as yup from 'yup';

export const signInFormSchema = yup.object().shape({
  newPassword: yup.string().required('nova senha obrigatória'),
  confirmNewpassword: yup
    .string()
    .required('confirmação de nova senha obrigatória'),
});
